// src/utils/axios.js
import axios from 'axios'
//import router from '../router'
import { authEvents } from '../eventBus'

//const authStore = useAuthStore()

// Pomocné funkce
function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
        return parts.pop().split(';').shift()
    }
    return null
}

function addCSRFToken(config) {
    // Pro GET requesty není potřeba CSRF token
    if (config.method === 'get') {
        return config
    }

    // Pro refresh endpoint použijeme refresh CSRF token
    if (config.url === '/refresh' || config.url === '/remove_refresh') {
        const refreshToken = getCookie('csrf_refresh_token')
        if (refreshToken) {
            config.headers['X-CSRF-REFRESH-TOKEN'] = refreshToken
        }
        return config
    }

    // Pro ostatní requesty použijeme access CSRF token
    const accessToken = getCookie('csrf_access_token')
    if (accessToken) {
        config.headers['X-CSRF-TOKEN'] = accessToken
    }
    return config
}

// Stav pro refresh token logiku
let isRefreshing = false
const failedQueue = []

function processQueue(error = null) {
    failedQueue.forEach(({ resolve, reject }) => {
        if (error) {
            reject(error)
        } else {
            resolve()
        }
    })
    failedQueue.length = 0  // Vyčistíme frontu
}

// Vytvoření axios instance
export const api = axios.create({
    withCredentials: true,
    baseURL: '/api'
})

export const api_simple = axios.create({
    baseURL: '/api',
    withCredentials: true
})

// Request interceptor
api.interceptors.request.use(addCSRFToken)
api_simple.interceptors.request.use(addCSRFToken)

// Response interceptor
async function handleResponse(response) {
    return response
}

async function handleError(error) {
    const originalRequest = error.config

    // Pokud nejde o 401 nebo už byl request retryován, propagujeme error dál
    if (error.response?.status !== 401 || originalRequest._retry) {
        return Promise.reject(error)
    }

    // Pokud už probíhá refresh, přidáme request do fronty
    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
        })
        .then(() => api(originalRequest))
        .catch((err) => Promise.reject(err))
    }

    // Pokusíme se refreshnout token
    try {
        originalRequest._retry = true
        isRefreshing = true

        await api_simple.post('/refresh')

        isRefreshing = false
        processQueue()

        return api(originalRequest)
    } catch (refreshError) {
        isRefreshing = false
        processQueue(refreshError)

        //router.push('/login')
        authEvents.dispatchEvent(new Event('auth:swlogout'))
        return Promise.reject(refreshError)
    }
}

api.interceptors.response.use(handleResponse, handleError)

